import React from 'react';

export const CartContext = React.createContext({
    cartItems: [],
    addToCart: () => {},
    clearCart: () => {},
    removeItem: () => {}, // Agrega esta función
  });